module.exports = __webpack_public_path__ + "img/install_theme_icon_4.e432af51.png";